export type EnvVarMap = Record<string, string>;

export type EnvVarDiff = {
  addedKeys: string[];
  modifiedKeys: string[];
  deletedKeys: string[];
  hasChanges: boolean;
};

export const getEnvVarDiff = (original: EnvVarMap = {}, current: EnvVarMap = {}): EnvVarDiff => {
  const originalKeys = Object.keys(original);
  const currentKeys = Object.keys(current);

  const originalKeySet = new Set(originalKeys);
  const currentKeySet = new Set(currentKeys);

  const addedKeys = currentKeys.filter((key) => !originalKeySet.has(key));
  const deletedKeys = originalKeys.filter((key) => !currentKeySet.has(key));
  const modifiedKeys = currentKeys.filter(
    (key) => originalKeySet.has(key) && original[key] !== current[key],
  );

  return {
    addedKeys,
    modifiedKeys,
    deletedKeys,
    hasChanges: addedKeys.length > 0 || modifiedKeys.length > 0 || deletedKeys.length > 0,
  };
};

export const toEnvVarChangeLists = (
  current: EnvVarMap,
  diff: EnvVarDiff,
): {
  addedEnvVars: string[];
  modifiedEnvVars: string[];
  deletedEnvVars: string[];
} => {
  return {
    addedEnvVars: diff.addedKeys.map((key) => `${key}: ${current[key]}`),
    modifiedEnvVars: diff.modifiedKeys.map((key) => `${key}: ${current[key]}`),
    deletedEnvVars: diff.deletedKeys,
  };
};
